'use client';

import { BlockData } from '@bw/apis/contentful';
import { ContentfulLivePreview } from '@contentful/live-preview';
import {
	useContentfulInspectorMode,
	useContentfulLiveUpdates,
} from '@contentful/live-preview/react';

type RenderProps<T extends BlockData> = {
	data: T;
	fieldId: (fieldId: keyof T['fields'] | '.') => ReturnType<typeof ContentfulLivePreview.getProps> | null;
};

export const LivePreviewWrapper = <T extends BlockData>({
	data: initialData,
	children: renderFn,
}: {
	data: T;
	children: (props: RenderProps<T>) => JSX.Element;
}) => {
	const data: T = useContentfulLiveUpdates(initialData);
	const inspectorProps = useContentfulInspectorMode({
		entryId: data.sys.id,
	});

	return renderFn({
		data,
		fieldId: (fieldId) => inspectorProps?.({ fieldId: String(fieldId) }),
	});
};
